


export const validateFields = (fields,type=1) => {

    let pass = true;

    let validation_fields = [
        'datalogics_fullname',
        'datalogics_phone',
        'datalogics_address',
        // 'datalogics_house',
        'datalogics_city'
    ];    

    if (type==2) {
        validation_fields = [            
            'shipping_push_supplier_name',
            'shipping_push_supplier_phone',
            // 'shipping_mark_fullfiled',
            // 'shipping_push_products_in_comments'
        ]
    } else {

        if (fields && typeof fields.datalogics_shipment_select !=='undefined' && fields.datalogics_shipment_select=="2") {
            validation_fields = [
                'datalogics_fullname',
                'datalogics_phone',
            ];
        }
        
    }

    for(let key in fields) {        

        if (validation_fields.indexOf(key)!==-1) {

            //console.log(key,validation_fields.indexOf(key),fields[key]);

            if (fields[key]=='') {
                //console.log(key,fields[key])
                pass = false;
            }

        } 

    }

    return pass;
    

}